module.exports = __WEBPACK_EXTERNAL_MODULE_54__;


//////////////////
// WEBPACK FOOTER
// external {"root":["dateFns","getYear"],"commonjs":"date-fns/get_year/index","commonjs2":"date-fns/get_year/index"}
// module id = 54
// module chunks = 0